import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';

export const useHistoryTabStyles = () => {
  return useStyles(({theme, mediaOnly}) => ({
    colText: {
      ...theme.fonts.h5Light,
      color: theme.color.textColor,
    },
    colTextPrimary: {
      ...theme.fonts.h5Light,
      color: theme.color.primaryColor,
    },
    colTextSecondary: {
      ...theme.fonts.h5Light,
      color: theme.color.iconGrayColor,
    },
    colHeadStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 12,
    },
    colBodyStyle: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingVertical: 16,
    },

    historyItem: {
      marginTop: 0,
      shadowColor: '#0000001A',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowRadius: 18,
      alignItems: 'flex-start',
      borderRadius: 14,
      backgroundColor: theme.color.backgroundMenuColor,
      elevation: 5,
    },

    historyHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    icon: {
      marginRight: 16,
      color: theme.color.primaryColor,
      justifyContent: 'center',
      height: 30,
    },

    text: {
      ...mediaOnly(DeviceSize.desktop, {...theme.fonts.h3, paddingHorizontal: 16}, {...theme.fonts.h5}),
    },

    emptyText: {
      ...mediaOnly(DeviceSize.desktop, {...theme.fonts.h4Light}, {fontSize: 16}),
      color: theme.color.labelText,
    },

    colorPrimary: {
      color: theme.color.primaryColor,
    },
  }));
};
